import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import { Reveal, Kicker } from "./Reveal";

export const Faq = ({ items, id }) => {
  const [openIdx, setOpenIdx] = useState(0);
  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: items.map((i) => ({
      "@type": "Question",
      name: i.q,
      acceptedAnswer: { "@type": "Answer", text: i.a },
    })),
  };
  return (
    <section className="py-20 md:py-28 border-t border-[#0A2B3D]/10" data-testid={`${id}-section`}>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
      <div className="max-w-4xl mx-auto px-5 sm:px-8">
        <Reveal>
          <Kicker>Common Questions</Kicker>
          <h2 className="mt-5 font-serif font-bold text-3xl sm:text-4xl text-[#0A2B3D] tracking-tight leading-[1.15]">
            Frequently asked questions.
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="mt-12 divide-y divide-[#0A2B3D]/10 border-y border-[#0A2B3D]/10">
            {items.map((item, i) => (
              <div key={item.q}>
                <button
                  onClick={() => setOpenIdx(openIdx === i ? -1 : i)}
                  data-testid={`${id}-question-${i}`}
                  aria-expanded={openIdx === i}
                  className="w-full flex items-center justify-between gap-6 py-6 text-left group"
                >
                  <span className="font-serif font-bold text-lg md:text-xl text-[#0A2B3D] group-hover:text-[#3E9BDC] transition-colors leading-snug">
                    {item.q}
                  </span>
                  <ChevronDown
                    size={20}
                    className={`shrink-0 text-[#3E9BDC] transition-transform duration-300 ${openIdx === i ? "rotate-180" : ""}`}
                  />
                </button>
                {openIdx === i && (
                  <div className="pb-7 text-[#475569] leading-relaxed max-w-3xl" data-testid={`${id}-answer-${i}`}>
                    {item.a}
                  </div>
                )}
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
};
